import { AbstractRenderer, BoxModelConstraint, BoxModelContext, ContentBox, SVG_NS } from '@blk/simba';
import { IconDirective } from '@ddt-web/generic-utils';

export class IconRenderer extends AbstractRenderer<SVGElement> {
	private iconObj: any;

	constructor(private icon: string, private height: number, private width: number, private colorTheme: string = '#000', private constraints?: Partial<BoxModelConstraint>) {
		super(constraints);
		this.iconObj = IconDirective.typeMap[this.icon];
		if (!this.iconObj) {
			throw new Error(`Icon ${this.icon} is missing.`);
		}
	}

	protected renderContent(context: BoxModelContext): ContentBox<SVGElement> {
		const svg: SVGElement = <SVGElement>document.createElementNS(SVG_NS, 'svg');

		if (this.iconObj.viewBox) {
			svg.setAttribute('viewBox', this.iconObj.viewBox);
		} else {
			svg.setAttribute('viewBox', IconDirective.DEFAULT_VIEW_BOX);
		}

		let height = this.height;
		let width = this.width;

		if (context.useFullWidth || width > context.availableWidth) {
			width = context.availableWidth;
		}

		if (height > context.availableHeight) {
			height = context.availableHeight;
		}

		svg.setAttribute('width', `${width}`);
		svg.setAttribute('height', `${height}`);

		const iconMarkup = this.iconObj.svg;
		const path: SVGPathElement = <SVGPathElement>document.createElementNS(SVG_NS, 'path');

		if (this.colorTheme) {
			svg.setAttribute('fill', this.colorTheme);
		}

		path.setAttribute('d', iconMarkup);
		svg.appendChild(path);

		return new ContentBox(svg, width, height);
	}
}
